import "../layouts/default";

import Swiper, { Pagination, Navigation } from "swiper";
import LazyLoad from "vanilla-lazyload";
import { initializeMap } from "Functions/map";

import "Ui/slider";
import "Ui/tabs";
import "Components/seen-products";

Swiper.use([Pagination, Navigation]);

const branches = window.branchesData;

window.mapLazyLoad = new LazyLoad({
    threshold: 125,
    elements_selector: ".js-map-branches",
    callback_enter: (el) => {
        initializeMap(".js-map-branches", branches);
    },
});
